module.exports = __webpack_public_path__ + "img/组 3035.554ef4f8.png";